

 const CommandType = {
        None : 0,
        GetUserData : 1,//ok
        SetUserData : 2,//ok
        SyncTime : 3,//ok
        SetTimeZones : 4,//ok
        SetTimeGroup : 5,//ok
        SetTimeSet : 6,//ok
        GetTimeZones : 7,
        GetTimeGroup : 8,
        GetTimeSet : 9,
        TakeOffManager : 10,//ok
        EmptyTimeLog : 11,//ok
        EmptyUserEnrollmentData : 12,//ok
        GetWiFiSetting : 13,
        SetWiFi : 14,
        GetEthernetSetting : 15,
        SetEthernet : 16,
        GetWiegandType : 17,
        SetWiegandType : 18,
        GetDoorOpenTime : 19,
        SetDoorOpenTime : 20,
        GetRelayType : 21,
        SetRelayType : 22,
        GetUserCount : 23,
        GetFirstUserData : 24,
        GetNextUserData : 25,
        GetFirstUserIds : 26,
        GetNextUserIds : 27,
        GetUserPassword : 28,//ok
        GetUserCardNo : 29,//ok
        GetFingerData : 30,//ok
        GetUserInfo : 31,

        GetJobCodes : 32,
        SetJobCodes : 33,//ok
        SetBulkUserData : 34,
        SetHoliday : 35,//ok
        SetDeviceInfo : 36,//OK
        LockControl : 37,//ok
        GetTime : 38,
        Restart : 39,//ok
        GetDoorCtrlSetting : 40,
        SetDoorCtrlSetting : 41,
        SetHostPCSettings : 42,
        SetGeneralSetting : 43,

        GetAllEmployees : 0x100,

        GetOpenDoorTimeZones : 200,
        SetOpenDoorTimeZones : 201,

        UpdateClientData : 300,
        UpdateProjectData : 301,
        UpdateJobData : 302,
        SetUserProjectJob : 303,
        DeleteUserProjectJob : 304,
        SetJobTrackingSetting : 305,
        SetUserProjectJobCompact : 306,
        DeleteUserProjectJobCompact : 307,

        SetSchedule : 310,
        SetBatchSchedule : 311,
        DeleteSchedule : 312,
        DeleteBatchSchedule : 313,
        SetPunchRestriction : 314,
        SetBreakRestriction : 315,
        SetBreakDefinition : 316,
        SetBreakRule : 317,
        SyncDeviceScheduleBatch : 318,

        SetQuestion : 320,
        SyncDeviceSchedule : 321,
        SyncTimeLog : 322,
        ResendTimeLogs : 323,
        SetFunctionKeys : 324,

        //AC group schedule commands
        SetAccessSchedule : 400,
        GetAccessSchedule : 401,
        SetAccessGroupUsers : 402,
        DeleteAccessGroupData : 403,
        SetAccessGroupUsersBatch : 404,//

        EnrollBothIris : 900,
        EnrollLeftIris : 901,
        EnrollRightIris : 902,
        EnrollFingerPrint : 903,
        GetIrisData : 904,

        IdentityObjectProcessed : 910,//ok

        //Device management commands
        ExecShellCommand : 10000,
        ForceDisconnect : 10001,
        EnableMqttSync : 10002,

        //Events
        Login : 100000,//ok
        LoginRequest : 100001,//ok
        KeepAlive : 100002,//ok
        TimeLog : 100003,//ok
        AdminLog : 100004,//ok
        ConnectionSetup : 100005,//ok
        IdentityObjectCaptured : 100006,//ok
        ANSI378_Template : 100007,//ok
        IdentityBirthdayOptained : 100008,//ok

        //Streaming
        Streaming : 200000,//ok
        UserPhoto : 200001,//ok
        UpdateApp : 200002,//ok
        UpdateModule : 200003,//ok
        NotifyNewUpdate : 200004,//no streaming
        SetWallpaper : 200005,

        //PatientVerify Mode
        PatientVerify : 999998
}
export default CommandType;


// WEBPACK FOOTER //
// ./src/utils/CommandType.js